import React from "react";
import styled from "styled-components";

const NoteProjectItem = ({ data }) => {
  const { name, description, techStacks, links } = data || {};
  return (
    <Container>
      <Wraper>
        <TopSection>
          <LinksWraper>
            <a href={links?.live} target="_blank" rel="preview">
              <Folder>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  role="img"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="1"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="feather feather-folder"
                >
                  <title>Folder</title>
                  <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path>
                </svg>
              </Folder>
            </a>
            <Links>
              {links?.frontend && (
                <a href={links?.frontend} target="_blank">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    role="img"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="feather feather-github"
                  >
                    <title>GitHub</title>
                    <path d="M9 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 0 0-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0 0 20 4.77 5.07 5.07 0 0 0 19.91 1S18.73.65 16 2.48a13.38 13.38 0 0 0-7 0C6.27.65 5.09 1 5.09 1A5.07 5.07 0 0 0 5 4.77a5.44 5.44 0 0 0-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 0 0 9 18.13V22"></path>
                  </svg>
                </a>
              )}
              {links?.live && (
                <a href={links?.live} target="_blank">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    role="img"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="feather feather-external-link"
                  >
                    <title>External Link</title>
                    <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
                    <polyline points="15 3 21 3 21 9"></polyline>
                    <line x1="10" y1="14" x2="21" y2="3"></line>
                  </svg>
                </a>
              )}
            </Links>
          </LinksWraper>

          <ProjectTitle>
            <a href={links?.live} target="_blank">
              {name}
            </a>
          </ProjectTitle>
          <ProjectDescription>
            <p>{description}</p>
          </ProjectDescription>
        </TopSection>

        <BottomSection>
          <ul>
            {techStacks?.length > 0 &&
              techStacks.map((item, i) => <li key={i}>{item}</li>)}
          </ul>
        </BottomSection>
      </Wraper>
    </Container>
  );
};

export default NoteProjectItem;

const Container = styled.li``;
const Wraper = styled.div`
  box-shadow: 0 10px 30px -15px var(--navy-shadow);
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  align-items: flex-start;
  position: relative;
  height: 100%;
  padding: 2rem 1.75rem;
  border-radius: var(--border-radius);
  background-color: var(--light-navy);
  transition: var(--transition);
  overflow: auto;
`;

// top section
const TopSection = styled.div``;
const LinksWraper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 35px;
`;
const Folder = styled.div`
  color: var(--green);

  svg {
    height: 40px;
    width: 40px;
  }
`;
const Links = styled.div`
  display: flex;
  align-items: center;
  margin-right: -10px;

  a {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 5px 7px;

    svg {
      height: 20px;
      width: 20px;
      transition: var(--transition);
      color: var(--lightest-slate);

      &:hover {
        color: var(--green);
      }
    }
  }
`;

const ProjectTitle = styled.h3`
  margin: 0px 0px 10px;
  color: var(--lightest-slate);
  font-size: var(--fz-xxl);
`;
const ProjectDescription = styled.div`
  color: var(--light-slate);
  font-size: 17px;
  font-family: ${(props) => props.theme.fonts.calibre_r};

  p {
    margin-bottom: 0px;
  }
`;

// bottom section
const BottomSection = styled.div`
  ul {
    display: flex;
    align-items: flex-end;
    flex-grow: 1;
    flex-wrap: wrap;
    padding: 0px;
    margin: 20px 0px 0px;
    list-style: none;

    li {
      font-family: ${(props) => props.theme.fonts.sf};
      font-size: var(--fz-xxs);
      line-height: 1.75;
      color: var(--slate);

      &:not(:last-of-type) {
        margin-right: 15px;
      }
    }
  }
`;
